export default {
	name: 'TheFooter',
	computed: {
		getYearDisplay(){
			return new Date().getFullYear();
		},
		showSideBar() {
			return this.$store.getters.getSideBar;
		},
		version() {
			return process.env.VUE_APP_VERSION;
		},
		build() {
			return process.env.VUE_APP_BUILD;
		}
	}
}
